module.exports = __webpack_public_path__ + "img/22.df6eca14.jpg";